"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const pit_1 = require("services/master-data/pit");
const contractor_1 = require("services/master-data/contractor");
const pit_types_1 = require("./pit.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, pit_1._getMasterPit)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: response.isError
        };
        dispatch({ type: pit_types_1.pitTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                const contractor = item.contractor_data.map(i => {
                    return (i === null || i === void 0 ? void 0 : i.contractor_code) || '';
                });
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), contractors: contractor.join(', ') });
            })
        };
        dispatch({ type: pit_types_1.pitTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, pit_1._getMasterPit)(dataStates);
    const payload = {
        dataGrid: res.isError ? [] : res.data.map(item => {
            const contractor = item.contractor_data.map(i => {
                return (i === null || i === void 0 ? void 0 : i.contractor_code) || '';
            });
            return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), contractors: contractor.join(', ') });
        }),
        dataStates
    };
    dispatch({ type: pit_types_1.pitTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: pit_types_1.pitTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode } = payload;
    const response = payload.mutationMode === 'add' ?
        yield (0, pit_1._createPit)({
            pit: payload.dataItem.pit,
            is_active: payload.dataItem.is_active,
            contractor_id: payload.dataItem.contractor_data.map(i => {
                return (i === null || i === void 0 ? void 0 : i.id) ? (i === null || i === void 0 ? void 0 : i.id) || '' : (i === null || i === void 0 ? void 0 : i.contractor_id) || '';
            })
        }) :
        yield (0, pit_1._editPit)({
            id: payload.dataItem.id,
            pit: payload.dataItem.pit,
            is_active: payload.dataItem.is_active,
            contractor_id: payload.dataItem.contractor_data.map(i => {
                return (i === null || i === void 0 ? void 0 : i.id) ? (i === null || i === void 0 ? void 0 : i.id) || '' : (i === null || i === void 0 ? void 0 : i.contractor_id) || '';
            })
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: pit_types_1.pitTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    }
    else {
        dispatch({
            type: pit_types_1.pitTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
    }
});
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, pit_1._deletePit)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: pit_types_1.pitTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
    }
    else {
        dispatch({
            type: pit_types_1.pitTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
    }
});
const getDetail = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseContractor = yield (0, contractor_1._getDropdownMasterContractorPit)();
    const dataContractor = responseContractor.data;
    dispatch({
        type: pit_types_1.pitTypes.GET_DETAIL,
        payload: {
            dataContractor,
        },
    });
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: pit_types_1.pitTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: pit_types_1.pitTypes.ON_SORT_CHANGE, payload });
};
const toggleError = payload => dispatch => {
    dispatch({ type: pit_types_1.pitTypes.SET_ERROR, payload });
};
const onLoading = () => dispatch => {
    dispatch({ type: pit_types_1.pitTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDetail,
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    onDelete,
    onFilterChange,
    onSortChange,
    toggleError,
    onLoading
};
